import { useSelector } from "react-redux";

import { resolveActiveNodesSelector } from "./querySelectors/index.ts";

export const useResolveActiveNodes = () => useSelector(resolveActiveNodesSelector);
